import ModelFactory from "../../../ModelFactory.js";
import NoAccessRight from "./NoAccessRight.js";
import ReadOnlyAccessRight from "./ReadOnlyAccessRight.js";
import ReadWriteAccessRight from "./ReadWriteAccessRight.js";

/**
 * Create instances of the subclasses of {@link AccessRight}.
 */
class AccessRightFactory extends ModelFactory {
	allClasses() {
		return [ReadWriteAccessRight, ReadOnlyAccessRight, NoAccessRight];
	}

	noAccessRight() {
		return NoAccessRight.instance();
	}

	_getTypeFromJson(type) {
		return type;
	}

	_instantiate(klass) {
		return klass.instance();
	}
}

const accessRightFactory = new AccessRightFactory();

export default accessRightFactory;
